// extracted by mini-css-extract-plugin
export default {"bar":"BarGraph_bar__xNWrr","text":"BarGraph_text__8p-UQ"};